import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const onboardingPagePlugin = createPlugin({
  id: 'onboarding-page',
  routes: {
    root: rootRouteRef,
  },
});

export const OnboardingPage = onboardingPagePlugin.provide(
  createRoutableExtension({
    name: 'OnboardingPage',
    component: () =>
      import('./components/OnboardingPage').then(m => m.OnboardingPage),
    mountPoint: rootRouteRef,
  }),
);
